import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const userSelfDelete = createAsyncThunk('userSelfDelete', async (data) => {
    try {
        const payload = {
            user_id: data?.user_id
        }
        if (data?.type) {
            payload.type = data.type
        }
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + `user_self_delete`,
            data: payload,
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})
